<template>
    <div class="service ">
      
        <div class="page_width">
           <div class="empty" style="height: 100px;"></div>
          <div class="page_title ">
              <div class="color2 text-l fs-f80">Terms of Use</div>
              <div class="title_tag color6 text-l">Last Updated: September 17, 2025</div>
          </div>
         
          <h3 class="title_big">Acceptance of Terms</h3>
          <div class="text_msg">By accessing or using Minglepay (the "Website"), you agree to be bound by these Terms of Use ("Terms"). If you do not agree with these Terms, please do not use the Website. These Terms apply to all visitors, users, and others who access the Website.</div>
          <div class="text_msg"> </div>
          <div class="text_msg"></div>

          <h3 class="title_big">Use of the Website</h3>
          <div class="text_msg color2">You agree to use the Website only for lawful purposes and in accordance with these Terms. You are prohibited from:</div>
          <div class="text_msg">Using the Website in any way that violates applicable laws or regulations. <br>Engaging in unauthorized access to or interference with the Website's systems or networks. 
            <br>Posting or transmitting harmful, offensive, or unlawful content. <br>Using automated systems (e.g., bots, scripts) to access or collect data from the Website without our permission.</div>
          <div class="text_msg"></div>

          <h3 class="title_big">Account Responsibilities</h3>
          <div class="text_msg color2">If you create an account on the Website, you are responsible for:</div>
          <div class="text_msg">Providing accurate and complete information during registration. 
            <br>Maintaining the confidentiality of your account credentials. 
            <br>Notifying us immediately of any unauthorized use of your account.We reserve the right to suspend or terminate your account if you violate these Terms. </div>
          <div class="text_msg"></div>

          <h3 class="title_big">Intellectual Property</h3>
          <div class="text_msg">All content on the Website, including text, graphics, logos, and software, is the property of Minglepay or its licensors and is protected by copyright, trademark, and other intellectual property laws. You may not reproduce, modify, distribute, or create derivative works from any content without our prior written consent.</div>
          <div class="text_msg"> </div>
          <div class="text_msg"></div>

          <h3 class="title_big">User Content</h3>
          <div class="text_msg">If you submit content to the Website (e.g., comments, reviews, or uploads), you grant us a non-exclusive, worldwide, royalty-free license to use, reproduce, modify, and display that content in connection with the Website. You represent that you own or have the necessary rights to submit such content.</div>
          <div class="text_msg"> </div>
          <div class="text_msg"></div>

          <h3 class="title_big">Disclaimers</h3>
          <div class="text_msg">The Website is provided on an "as-is" and "as-available" basis. We make no warranties, express or implied, regarding the Website's availability, accuracy, or fitness for a particular purpose. We do not guarantee that the Website will be free of errors, viruses, or other harmful components.</div>
          <div class="text_msg"> </div>
          <div class="text_msg"></div>

          <h3 class="title_big">Limitation of Liability</h3>
          <div class="text_msg">To the fullest extent permitted by law, Minglepay and its affiliates shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the Website or inability to access it, even if we have been advised of the possibility of such damages.</div>
          <div class="text_msg"> </div>
          <div class="text_msg"></div>

          <h3 class="title_big">Termination</h3>
          <div class="text_msg">We reserve the right to suspend or terminate your access to the Website at our sole discretion, without notice, for any reason, including violation of these Terms.</div>
          <div class="text_msg"> </div>
          <div class="text_msg"></div>
          <h3 class="title_big">Governing Law</h3>
          <div class="text_msg">These Terms shall be governed by and construed in accordance with the laws of Hong Kong. Any disputes arising from these Terms or your use of the Website shall be resolved exclusively in the courts of Hong Kong.</div>
          <div class="text_msg"> </div>
          <div class="text_msg"></div>

          <h3 class="title_big">Changes to These Terms</h3>
          <div class="text_msg">We may update these Terms from time to time. The updated version will be posted on this page with a revised "Last Updated" date. Your continued use of the Website after such changes constitutes your acceptance of the revised Terms.</div>
          <div class="text_msg"> </div>
          <div class="text_msg"></div>

          <h3 class="title_big">Contact Us</h3>
          <div class="text_msg">If you have questions or concerns about this Privacy Policy, please contact us at:  </div>
          <div class="text_msg">Email: business@Minglepay.net  </div>
          <div class="text_msg">Address: Room 1605, Good View Commercial Centre, 2-16 Fa Yuen Street, Mong Kok, Kowloon</div>
          <div class="text_msg"></div>

          <h3 class="title_big"></h3>
          <div class="text_msg"></div>
          <div class="text_msg"> </div>
          <div class="text_msg"></div>

          <h3 class="title_big"></h3>
          <div class="text_msg"></div>
          <div class="text_msg"> </div>
          <div class="text_msg"></div>

          <h3 class="title_big"></h3>
          <div class="text_msg"></div>
          <div class="text_msg"> </div>
          <div class="text_msg"></div>

        
          
        </div>
    </div>
  </template>
  
  <script>
  
  export default {
    data(){
        return{
  
        }
    },
    methods:{
       goTop(e){
        document.querySelector(e).scrollIntoView(true);
      }
    },
    created(){
     
    }
  
  }
  </script>
  
  <style scoped>
  
  </style>